// eslint-disable-next-line no-unused-vars
import { Action } from "../../../personal-studio-components/frame";
// eslint-disable-next-line no-unused-vars
import { SchemaJSON } from "../../../personal-studio-components/form";
// eslint-disable-next-line no-unused-vars
import { TableModel } from "../../../personal-studio-components/table";
export { QuestionsModel };
/**
 * Модель страницы "Консультации".
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class QuestionsModel {
  /**
   * Заголовок виджета.
   * @type {string}
   */
  title = "Консультации";
  /**
   * Иконка виджета.
   * @type {string}
   */
  icon = "dialog_question";
  /**
   * Список дисциплин.
   * @type {Array.<QuestionsModel~Discip>}
   */
  discips;
  /**
   * Номер открытого чатрума (`question_tutor_id`)
   * @type {integer}
   */
  chat_room = 0;
  /**
   * Модель таблицы.
   * @type {TableModel}
   */
  table;
  /**
   * Состояние диалога: открыт (true) | закрыт (false).
   * @type {boolean}
   */
  open = false;
  /**
   * Переменные окружения, подставляемые в каждый запрос.
   * @type {Object}
   */
  env = {};
  /**
   * Открывает/закрывает диалог.
   * @param {Event | Object} event - Событие.
   */
  onClick = (event) => {};
  /**
   * Отправляет запрос на добавление вопроса.
   * @param {Object} data - Данные формы.
   */
  onSubmit = (data) => {};
  /**
   * Открывает чатрум.
   * @param {Event | Object} event - Событие.
   */
  onOpenChatRoom = (event) => {};
  /**
   * Закрывает чатрум.
   * @param {Event | Object} event - Событие.
   */
  onCloseChatRoom = (event) => {};
  /**
   * @returns {Array.<Action>} Меню виджета.
   */
  getMenu = () => [
    {
      name: "Задать новый вопрос",
      icon: "new_file",
      href: "#open",
      onClick: this.onClick,
    },
  ];
  /**
   * @returns {Request} Запрос на загрузку таблицы.
   */
  getRequest = () => ({
    method: "post",
    path: "/student/question_tutor/list",
    data: {
      ...this.env,
    },
  });
  /**
   * @returns {Request} Запрос на добавление вопроса.
   * @param {Object} data - Данные формы.
   */
  getSubmitRequest = (data) => ({
    method: "post",
    path: "/student/question_tutor/add",
    data: {
      ...this.env,
      ...data,
    },
  });
  /**
   * @returns {SchemaJSON} Схема формы для диалога добавления вопроса.
   */
  getSchema = () => ({
    title: "Задать новый вопрос",
    properties: {
      mod_discip_id: {
        title: "Дисциплина",
        type: "integer",
        enum: this.discips.map((x) => x.mod_discip_id),
        enumTitle: this.discips.map((x) => x.mod_discip_name),
      },
      text: {
        title: "Текст вопроса",
        type: "string",
        rows: 7,
      },
      attachments: {
        title: "Вложения",
        type: "array",
        items: {
          type: "string",
        },
      },
    },
    required: ["mod_discip_id", "text"],
    actions: [
      {
        name: "Отправить",
        type: "primary",
      },
      {
        name: "Отмена",
        onClick: this.onClick,
      },
    ],
    onSubmit: this.onSubmit,
  });
  /**
   * Разбор ответа от сервера.
   * @param {Object} response - Ответ от сервера.
   */
  parseResponse(response) {
    this.discips = response.discips;
    this.table = {
      columns: [
        ...response.columns,
        {
          field: "chat_room",
          headerName: "Посмотреть",
          type: "link",
        },
      ],
      rows: response.rows.map((row) => ({
        ...row,
        chat_room: {
          name: "Посмотреть",
          icon: "link",
          href: "#" + row.question_tutor_id,
          question_tutor_id: row.question_tutor_id,
          onClick: this.onOpenChatRoom,
        },
      })),
    };
  }
  /**
   * Копирует свойства объекта.
   * @param {BringFriendModel} props - Свойства объекта.
   */
  constructor(props) {
    Object.assign(this, props);
  }
}
